module.exports = __webpack_public_path__ + "img/pills-dosing.d3f607b1.png";